module.exports = __webpack_public_path__ + "static/media/profile_image_placeholder_elliot.432d61fd.jpg";